import { render, staticRenderFns } from "./JVxeCheckboxCell.vue?vue&type=template&id=c47628d6"
import script from "./JVxeCheckboxCell.vue?vue&type=script&lang=js"
export * from "./JVxeCheckboxCell.vue?vue&type=script&lang=js"
import style0 from "./JVxeCheckboxCell.vue?vue&type=style&index=0&id=c47628d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports